import NotFound from "theme/modules/PageError/NotFound";
import withEntityNotFound from "theme/modules/PageError/NotFound/withEntityNotFound";

export default withEntityNotFound({ isFound: () => false })(NotFound);
